export default "__VITE_ASSET__BLigk$Ca__"